var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgLinkOut = function SvgLinkOut(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9241 2.61722C21.8757 2.50014 21.804 2.3904 21.7092 2.29502C21.7078 2.2936 21.7064 2.29219 21.705 2.29078C21.5242 2.11106 21.2751 2 21 2H20.9998H12C11.4477 2 11 2.44772 11 3C11 3.55228 11.4477 4 12 4H18.5858L8.79289 13.7929C8.40237 14.1834 8.40237 14.8166 8.79289 15.2071C9.18342 15.5976 9.81658 15.5976 10.2071 15.2071L20 5.41421V12C20 12.5523 20.4477 13 21 13C21.5523 13 22 12.5523 22 12V3.00069V3C22 2.999 22 2.998 22 2.997C21.9996 2.8625 21.9727 2.73425 21.9241 2.61722Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 3.44772 2.44772 3 3 3H7C7.55228 3 8 3.44772 8 4C8 4.55228 7.55228 5 7 5H4V20H19V17C19 16.4477 19.4477 16 20 16C20.5523 16 21 16.4477 21 17V21C21 21.5523 20.5523 22 20 22H3C2.44772 22 2 21.5523 2 21L2 4Z",
    fill: "black"
  })));
};
export { SvgLinkOut as ReactComponent };
export default __webpack_public_path__ + "static/media/link-out.8c941b81.svg";